import { User } from '@spa/store/modules/user/types'
import { LoginError, UserNotFetchedError } from '../../modal-state'
import { SpecificationList, success, ValidationResult } from './index'

interface UserSpecification {
  validate(input: User | undefined | null): ValidationResult
}

export class UserSpecificationList
  extends SpecificationList<User, UserSpecification>
  implements UserSpecification {}

export class LoginSpecification implements UserSpecification {
  constructor(private readonly postProcess: () => void) { }

  validate(input: User | undefined | null): ValidationResult {
    if (input) {
      return success()
    }

    return {
      modalState: new LoginError(),
      postProcess: this.postProcess,
      isInvalid: true,
    }
  }
}

export class UserMustExistSpecification implements UserSpecification {
  constructor(private readonly postProcess: () => void) { }

  validate(input: User | undefined | null): ValidationResult {
    if (input) {
      return success()
    }

    return {
      modalState: new UserNotFetchedError(),
      postProcess: this.postProcess,
      isInvalid: true,
    }
  }
}
